export const getAccessToken = () => localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
// Clear only the auth keys, not the whole store. A single 401 (e.g. a new
// browser context that starts with no sessionStorage token) used to call
// sessionStorage.clear() / localStorage.clear() and wipe everything,
// including the cached `user` and any unrelated keys.
export const deleteSessionData = () => sessionStorage.removeItem('accessToken');
export const storeAccessToken = (accessToken) => sessionStorage.setItem('accessToken', accessToken);

// store token in case of remember me is checked
export const storeToken = (accessToken) => localStorage.setItem('accessToken', accessToken);
export const deleteToken = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
};

// Path: src/utils/auth-token-utils/jwt.js
export const storeUserInfo = (userData) => localStorage.setItem('user', JSON.stringify(userData));
export const getUserInfo = () => JSON.parse(localStorage.getItem('user')) || {};
